import { useState, useEffect } from "react";
import Confetti from "react-confetti-boom";

export default function ConfettiComp({ colors }) {
    const [showConfetti, setShowConfetti] = useState(true);
    
    // Default colors - you can customize these or pass custom colors via props
    const defaultColors = [
        '#FFD700', // Gold
        '#FF6347', // Tomato
        '#32CD32', // LimeGreen
        '#1E90FF', // DodgerBlue
        '#FF1493', // DeepPink
        '#00CED1', // DarkTurquoise
        '#FFA500', // Orange
        '#9370DB'  // MediumPurple
    ];

    const confettiColors = colors || defaultColors;

    useEffect(() => {
        // Hide confetti after 3 seconds (particles will naturally fall)
        const timer = setTimeout(() => {
            setShowConfetti(false);
        }, 3000);

        return () => {
            clearTimeout(timer);
        };
    }, []);

    if (!showConfetti) {
        return null;
    }

    return(
        <Confetti
            mode="boom"
            particleCount={200}
            spreadDeg={60}
            colors={confettiColors}
        />
    );
}